<div
    class="d-flex flex-column justify-content-center align-items-center h-100 w-100"
>
    <div>
        <ng-content></ng-content>
    </div>
</div>
